import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class HotkeysInitService {
    initializeApp () {
        const angular = (window as any).angular;
        if (!angular?.module) {
            return;
        }
        const setHotkeys = () => {
            try {
                const $injector = angular.element(document.body).injector();
                const hotkeys = $injector.get('hotkeys');
                (window as any).angularJsHotkeys = hotkeys.get();
            } catch {
                (window as any).angularJsHotkeys = [];
            }
        };
        setHotkeys();
        setInterval(() => {
            setHotkeys();
        }
        , 500);
    }
}

